var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 656.549,
    height: 102.45,
    viewBox: "0 0 656.549 102.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.143,
    y1: 0.5,
    x2: 6.399,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#84d9d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07cdae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.143,
    y1: 0.501,
    x2: 6.408,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.143,
    y1: 0.501,
    x2: 6.408,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.021,
    y1: 0.831,
    x2: 0.964,
    y2: 0.797,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84d9d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07cdae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-739 -383.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M100.2,30,53.1,6.5a4.028,4.028,0,0,0-3.7,0L2.3,30A4.228,4.228,0,0,0,0,33.7a4.114,4.114,0,0,0,2.3,3.7L49.4,61a4.058,4.058,0,0,0,1.9.4,4.333,4.333,0,0,0,1.9-.4l47.1-23.5a4.114,4.114,0,0,0,2.3-3.7A4.558,4.558,0,0,0,100.2,30Zm-49,22.7-37.8-19L51.2,14.8,89,33.7Z",
    transform: "translate(739.028 377)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M102,79a4.248,4.248,0,0,0-5.6-1.9L51.2,99.8,6,77.1a4.182,4.182,0,0,0-3.7,7.5l47.1,23.5a4.058,4.058,0,0,0,1.9.4,4.333,4.333,0,0,0,1.9-.4l47.1-23.5A4.329,4.329,0,0,0,102,79Z",
    transform: "translate(739.028 377)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M102,55.4a4.248,4.248,0,0,0-5.6-1.9L51.2,76.2,6,53.6a4.182,4.182,0,0,0-3.7,7.5L49.4,84.6a4.058,4.058,0,0,0,1.9.4,4.333,4.333,0,0,0,1.9-.4l47-23.6A4.21,4.21,0,0,0,102,55.4Z",
    transform: "translate(739.028 377)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M83.877-7.013v-4.2c-7.746-.968-9.359-2.582-13.393-12.99-7.907-20.171-15.41-40.745-23.156-61.319l-6.213,1.533L16.346-23.8C12.231-13.629,10.94-12.177,2.71-11.209l-.161,4.2H29.578v-4.2c-8.794-1.13-9.036-2.824-7.261-8.23,1.372-4.76,3.066-9.117,4.438-12.99h23.4c2.017,5.083,3.873,10.166,5.083,13.635,1.775,5,1.291,6.374-5.89,7.584v4.2ZM47.893-38.722H28.851c3.066-8.391,6.293-16.943,9.682-25.415h.323ZM148.423-28.636c-2.42,6.132-4.6,9.843-6.858,12.344-2.824,3.147-7.261,3.953-12.425,3.953-3.792,0-6.939-.081-9.2-.888-2.5-1.049-2.9-3.066-2.9-8.633v-46.07c0-10.085,1.13-10.811,10.408-11.618v-4.2H90.412v4.2c9.359.807,10.65,1.533,10.65,11.618v44.94c0,10.247-1.291,10.892-12.022,11.78v4.2h59.14c.888-3.308,3.469-15.168,4.438-20.332Zm74.793-55.106h-28v4.2c8.875,1.21,8.956,2.824,6.939,7.665-2.824,6.777-9.036,17.831-12.586,24.77-4.76-8.794-9.843-17.508-14.039-25.576-2.178-4.115-2.178-5.809,5.809-6.858v-4.2H146.809v4.2c6.7,1.049,8.794,2.34,13.393,10.327,7.1,11.941,11.618,20.009,14.926,26.383a11.361,11.361,0,0,1,1.694,6.455v12.909c0,10.811-1.21,11.538-11.538,12.344v4.115H204.5v-4.115c-10.811-.807-11.618-1.533-11.618-12.344V-38.641a13.936,13.936,0,0,1,2.1-8.068c5.89-10.973,9.2-15.975,13.555-22.833,4.438-6.7,6.939-9.2,14.684-10Zm89.477,0H282.276v4.2c8.23.484,11.054,2.985,11.7,7.1a77.614,77.614,0,0,1,1.291,16.056v12.1c0,19.848-6.213,31.063-21.139,31.063-13.232,0-19.929-10.973-19.929-28.8V-66.557c0-11.457,1.291-12.183,10.327-12.99v-4.2H227.815v4.2c9.036.807,10.327,1.533,10.327,12.99v27.19c0,13.8,3.469,22.833,10.408,28.158,5.728,4.276,13.393,6.051,21.462,6.051,8.472,0,16.782-3.066,22.349-8.633,6.939-7.1,8.956-16.943,8.956-29.772V-56.391c0-7.988.4-12.425,1.049-15.975.645-4.2,3.711-6.777,10.327-7.181Zm53.9,18.476c-.888-7.584-1.775-12.829-2.178-17.1a53.613,53.613,0,0,0-16.943-3.147c-16.782,0-27.513,10.085-27.513,23.237,0,11.3,8.31,17.67,20.9,23.8,9.036,4.518,14.442,8.875,14.442,15.814,0,7.665-4.68,12.587-12.1,12.587-11.457,0-18.88-13.635-21.139-21.139l-4.2,1.291c.807,7.181,2.42,17.508,3.55,20.332a52.992,52.992,0,0,0,7.261,2.663,41.113,41.113,0,0,0,12.183,1.775c17.508,0,29.288-10.65,29.288-24.2,0-11.7-8.552-18.315-21.3-24.285-10.811-5.164-15.168-8.875-15.168-15.33,0-6.7,4.841-11.7,11.941-11.7,9.682,0,14.523,8.875,16.863,16.3Zm70.92,37.437c-2.178,5.325-4.438,9.2-6.777,11.78-2.824,3.066-7.423,3.711-13.393,3.711-4.438,0-8.956-.161-11.054-1.13-2.5-1.049-2.9-4.115-2.9-9.763V-43.24h8.23c10.166,0,11.86.484,13.393,8.956h4.357V-58.247H425c-1.533,8.23-3.227,8.956-13.393,8.956h-8.23V-74.383c0-3.873.323-4.115,5-4.115h6.132c6.374,0,9.6.888,11.78,2.985s3.953,6.213,5,10.327l4.357-.565c-.484-7.665-1.049-15.894-1.13-17.992H377.4v4.2c8.714.726,9.843,1.291,9.843,11.78v44.86c0,10.166-1.13,10.811-11.618,11.7v4.2h61.884c.968-3.55,3.469-14.442,4.276-19.848Zm85.04,17.912a16.014,16.014,0,0,1-7.181-4.841c-2.34-2.5-5-6.374-9.279-12.909-3.631-5.406-8.068-13.232-9.843-16.7,7.988-3.066,15.007-8.714,15.007-19.2a18.364,18.364,0,0,0-7.988-15.733c-4.922-3.308-11.054-4.438-21.946-4.438H447.837v4.2c8.794.726,10,2.1,10,11.538v45.1c0,9.682-1.533,10.731-10.489,11.7v4.2H483.74v-4.2c-9.117-.968-10.327-2.017-10.327-11.7V-39.932h2.34c3.873,0,6.132,1.452,8.149,4.922,3.55,6.293,6.7,12.586,9.843,17.427,4.841,7.423,9.521,10.811,24.85,11.538,1.372,0,2.662.081,3.227.081ZM473.413-44.611v-28.8c0-2.34.242-3.631,1.049-4.357.888-.726,2.5-1.291,5.648-1.291,6.858,0,14.281,4.6,14.281,17.185,0,5.971-1.694,10.569-5.809,14.119-2.663,2.34-6.939,3.147-12.183,3.147Z",
    transform: "translate(873 475.568)",
    fill: "url(#linear-gradient-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e846be4e3d8be82ffa8c183f07de9c9.svg";
export { ForwardRef as ReactComponent };